import { createStatusChip } from 'components/status-chip'
import { REQUEST_STATUS, STATUS_LABELS } from './utils'

const OVERDUE = 'OVERDUE'

const StatusChip = createStatusChip({
  [REQUEST_STATUS.PURCHASED]: {
    label: STATUS_LABELS[REQUEST_STATUS.PURCHASED],
    color: 'gray',
  },
  [REQUEST_STATUS.READY_TO_ANALYZE]: {
    label: STATUS_LABELS[REQUEST_STATUS.READY_TO_ANALYZE],
    color: 'active',
  },
  [REQUEST_STATUS.COMPLETE]: {
    label: STATUS_LABELS[REQUEST_STATUS.COMPLETE],
    color: 'success',
  },
  [OVERDUE]: { label: 'Overdue', color: 'danger' },
})

const RequestStatusChip = ({ status, overdue = false, size = 'small' }) => (
  <StatusChip status={overdue ? OVERDUE : status} size={size} />
)

export default RequestStatusChip
